// ---------------------------------------------------------------------------------------------------------------------
// Player video
// ---------------------------------------------------------------------------------------------------------------------
const playerVideoWraps = document.querySelectorAll('.js_player_video')
// const iframeVideoWraps = document.querySelectorAll('.js_iframe_video')

function isVideoPlaying(video) {
  return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
}


function playVideo(videoWrap, video, playButton) {
  stopAllPlayerVideos();
  // stopAllYouTubeVideos();
  videoWrap.classList.add('playing');
  if (!isVideoPlaying(video)) {
    video.play();
  }
}


//init only if page has play videos
function playerVideo() {
  if (playerVideoWraps !== undefined) {
    playerVideoWraps.forEach(function (element, index) {

      const videoWrap = element
      const video = element.querySelector('video')
      const playButton = element.querySelector('.js_player_video_overlay')

      playButton.addEventListener('click', function (e) {
        playVideo(videoWrap, video, playButton);
      });

      video.addEventListener('pause', function (e) {
        videoWrap.classList.remove('playing');
      });

      video.addEventListener('play', function (e) {
        videoWrap.classList.add('playing');
      });

    });
  }
}

playerVideo();

// ---------------------------------------------------------------------------------------------------------------------
// Play only one video on the page
// ---------------------------------------------------------------------------------------------------------------------

function stopAllPlayerVideos() {
  if (playerVideoWraps !== undefined) {
    playerVideoWraps.forEach(function (element, index) {
      const videoWrap = element
      const video = element.querySelector('video')

      video.pause();
      videoWrap.classList.remove('playing');
    });
  }
}







function onPlayerStateChange(event) {
  let playerStatus = event.data
  if (playerStatus === 1) { // playing
    // pauseAllYoutubeVideosExcept(event.target.h);
    stopAllPlayerVideos();
  }
}

console.log('TEST');





